module.exports = __webpack_public_path__ + "static/TT1442_TW-MKD01a-9644e5760440adec617aa1cedb985b3f.png";